'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useMediaQuery = require('../../utils/hooks/useMediaQuery.js');
var breakpoint = require('../../utils/breakpoint.js');
require('./Modal.scss.js');
var CSSTransition = require('../../../node_modules/react-transition-group/esm/CSSTransition.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Modal = function (props) {
    var _a = React.useState(props.defaultSize), size = _a[0], setSize = _a[1];
    var _b = React.useState(props.isOpen), openModal = _b[0], setOpenModal = _b[1];
    var isDesktop = useMediaQuery.useMediaQuery(breakpoint.BREAK_POINTS.desktop);
    var isTablet = useMediaQuery.useMediaQuery(breakpoint.BREAK_POINTS.tablet);
    // when user resizes the window it's equivalent effect on visible slides
    React.useEffect(function () {
        if (isDesktop) {
            setSize(props.defaultSize);
        }
        else if (isTablet) {
            setSize('md');
        }
        else {
            setSize('sm');
        }
    }, [isTablet, isDesktop]);
    var classIsShow = openModal ? 'show' : '';
    var classSize = "lp__modal-dialog--" + size;
    var classNameParent = props.className ? props.className : '';
    var buttonClose = function () { return (React__default['default'].createElement("button", { type: "button", className: "lp__modal-close-button", onClick: function () { return setOpenModal(false); }, "aria-label": "Close" },
        React__default['default'].createElement("span", { "aria-hidden": "true" }, "\u00D7"))); };
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("div", { className: "lp__modal " + classNameParent + " " + classIsShow },
            React__default['default'].createElement(CSSTransition, { in: openModal, timeout: 300, classNames: "lp__modal-dialog" },
                React__default['default'].createElement("div", { className: "lp__modal-dialog " + classSize },
                    React__default['default'].createElement("div", { className: "lp__modal-content" },
                        props.header && (React__default['default'].createElement("div", { className: "lp__modal-header" },
                            buttonClose(),
                            props.header)),
                        React__default['default'].createElement("div", { className: "lp__modal-body" },
                            !props.header && buttonClose(),
                            props.children),
                        props.footer && (React__default['default'].createElement("div", { className: "lp__modal-footer" }, props.footer)))))),
        React__default['default'].createElement("div", { className: "lp__modal-backdrop " + classIsShow })));
};

exports.Modal = Modal;
//# sourceMappingURL=Modal.js.map
